.spaBothDatesRow {
	height: 100%;
	padding-top: 8px;
}
